module.exports = __webpack_public_path__ + "img/html_5.4d5136e5.svg";